module.exports = __webpack_public_path__ + "img/sg.3456b2a7.png";